import React from 'react';
import { Button, DatePicker } from 'antd';
import dayjs from 'dayjs';

const MonthSelect = ({ yearMonth, setYearMonth }) => {
    const handleDateChange = (date) => {
        setYearMonth(dayjs(date).format('YYYY-MM'));
    }

    const handleGoToPreviousMonth = () => {
        if(dayjs(yearMonth).isBefore(dayjs('2024-12'))) return;
        setYearMonth(dayjs(yearMonth).subtract(1, 'month').format('YYYY-MM'));
    }

    const handleGoToNextMonth = () => {
        if(dayjs(yearMonth).isAfter(dayjs())) return;
        setYearMonth(dayjs(yearMonth).add(1, 'month').format('YYYY-MM'));
    }

    return (
        <div style={{ marginRight: '10px'}}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Button
                    onClick={handleGoToPreviousMonth}
                    style={{ marginRight: '5px', alignSelf: 'center' }}
                    disabled={dayjs(yearMonth).subtract(1, 'month').isBefore(dayjs('2024-12'))}
                >
                    이전달
                </Button>
                <DatePicker
                    picker="month"
                    minDate={dayjs('2024-12')}
                    maxDate={dayjs()}
                    value={dayjs(yearMonth)}
                    onChange={handleDateChange}
                    allowClear={false}
                    style={{ marginRight: '5px' }}
                />
                <Button
                    onClick={handleGoToNextMonth}
                    style={{ alignSelf: 'center' }}
                    disabled={dayjs(yearMonth).add(1, 'month').isAfter(dayjs())}
                >
                    다음달
                </Button>
            </div>
        </div>
    );
}

export default MonthSelect;